<div class="main-container flex flex-col justify-center items-center">
	@if (displayWarningMsg) {
		<pin-notification type="warning">
			The option to use email as your Second-Factor Authentication is no longer available.
			Please select an alternative method for Second-Factor Authentication to protect your account.
		</pin-notification>
	}

	<div class="flex flex-col justify-center items-center gap-2 mb-10 title-container">
		<div class="dcp-h1 flex justify-center">Set Up Stronger Security For Your Account</div>

		<div class="dcp-body text">
			For your security, we will ask you for a different verification code each time you log in.
			How would you like to receive the verification code?
		</div>
	</div>

	<div class="flex flex-col md:flex-row gap-6 md:gap-8 justify-center items-center w-full">
		<mat-card id="mfa-app-card" data-testid="mfa-app-card" appearance="outlined" class="flex flex-col justify-start items-center mfa-card gap-10"
		          (click)="useMobileApp()" (keyup.enter)="useMobileApp()" tabindex="0">
			<img src="../../../../assets/img/MFA_APP.svg" class="mobile-app-img" alt="Illustration of a mobile phone with app icon on screen.">
			<div class="card-text flex flex-col gap-2">
				<div id="mfa-mobile-app-title" class="dcp-h2">MOBILE APP</div>
				<div id="mfa-mobile-app-text" class="dcp-body text">
					Use an app on your smart phone to receive your verification code.
				</div>
			</div>
		</mat-card>
        <mat-card id="mfa-email-card" data-testid="mfa-email-card" appearance="outlined" class="flex flex-col justify-start items-center mfa-card gap-10"
                  (click)="useEmail()" (keyup.enter)="useEmail()" tabindex="0">
            <img src="../../../../assets/img/MFA_EMAIL.svg" class="email-img" alt="Illustration of a laptop with envelope on screen.">
            <div class="card-text flex flex-col gap-2">
                <div id="mfa-email-title" class="dcp-h2">EMAIL</div>
                <div id="mfa-email-text" class="dcp-body text">
                    Receive a one-time verification code at the email address associated with your account.
                </div>
            </div>
        </mat-card>
	</div>

    @if (displayCancelButton) {
        <div class="flex justify-center mt-10 -mb-6">
			<pin-button buttonId="skip-mfa-setup-button" buttonStyle="link" (buttonClick)="skipMfaSetup()">Cancel</pin-button>
        </div>
    }
</div>

@if (isLoading) {
	<div class="pin-spinner fullscreen">
	  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
	</div>
}
